import i18next from 'i18next'
import {ROUTES} from '@/router/routes'
import {hasPermissions} from '@/stores/auth/services'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'
import {SettingsColumnItem, SettingsColumnsConfig} from '@/stores/settings'
import {USER_GUIDE_SELECTORS} from '@/constants/user-guide/user-guide'

export const getSettingsColumns = ({
    onCardClick,
    dossierMerchantStore
}: SettingsColumnsConfig): SettingsColumnItem[] => {
    return [
        ...(hasPermissions([
            PermissionsMap.merchant.profile.read,
            PermissionsMap.merchant.profile.full,
            PermissionsMap.merchant.bank_accounts.read,
            PermissionsMap.merchant.bank_accounts.full
        ])
            ? [
                  {
                      title: i18next.t('settings.columnHeader.business'),
                      items: [
                          ...(hasPermissions([
                              PermissionsMap.merchant.profile.read,
                              PermissionsMap.merchant.profile.full
                          ]) && dossierMerchantStore?.dossierMerchantData?.mainInfo
                              ? [
                                    {
                                        title: i18next.t('settings.cardTitle.companyProfile'),
                                        description: i18next.t(
                                            'settings.cardDescription.companyProfile'
                                        ),
                                        onClick: () => onCardClick(ROUTES.settings.companyProfile),
                                        classname: USER_GUIDE_SELECTORS.companyProfileCard
                                    }
                                ]
                              : []),
                          ...(hasPermissions([
                              PermissionsMap.merchant.bank_accounts.read,
                              PermissionsMap.merchant.bank_accounts.full
                          ])
                              ? [
                                    {
                                        title: i18next.t('settings.cardTitle.bankAccounts'),
                                        description: i18next.t(
                                            'settings.cardDescription.bankAccounts'
                                        ),
                                        onClick: () => onCardClick(ROUTES.settings.bankAccounts),
                                        classname: USER_GUIDE_SELECTORS.bankAccountsCard
                                    }
                                ]
                              : [])
                      ]
                  }
              ]
            : []),
        ...(hasPermissions([
            PermissionsMap.merchant.ecom_stores.read,
            PermissionsMap.merchant.ecom_stores.full,
            PermissionsMap.merchant.pos_stores.read,
            PermissionsMap.merchant.pos_stores.full,
            PermissionsMap.payment_methods.read,
            PermissionsMap.payment_methods.full
        ])
            ? [
                  {
                      title: i18next.t('settings.columnHeader.outletsNProducts'),
                      items: [
                          ...(hasPermissions([
                              PermissionsMap.merchant.pos_stores.read,
                              PermissionsMap.merchant.pos_stores.full
                          ])
                              ? [
                                    {
                                        title: i18next.t('settings.cardTitle.posOutlets'),
                                        description: i18next.t(
                                            'settings.cardDescription.posOutlets'
                                        ),
                                        onClick: () => onCardClick(ROUTES.settings.posOutlets),
                                        classname: USER_GUIDE_SELECTORS.posOutletsCard
                                    }
                                ]
                              : []),
                          ...(hasPermissions([
                              PermissionsMap.merchant.ecom_stores.read,
                              PermissionsMap.merchant.ecom_stores.full
                          ])
                              ? [
                                    {
                                        title: i18next.t('settings.cardTitle.onlineOutlets'),
                                        description: i18next.t(
                                            'settings.cardDescription.onlineOutlets'
                                        ),
                                        onClick: () => onCardClick(ROUTES.settings.onlineOutlets),
                                        classname: USER_GUIDE_SELECTORS.onlineOutletsCard
                                    }
                                ]
                              : []),
                          ...(hasPermissions([
                              PermissionsMap.payment_methods.read,
                              PermissionsMap.payment_methods.full
                          ])
                              ? [
                                    {
                                        title: i18next.t('settings.cardTitle.paymentMethods'),
                                        description: i18next.t(
                                            'settings.cardDescription.paymentMethods'
                                        ),
                                        onClick: () => onCardClick(ROUTES.settings.paymentMethods),
                                        classname: USER_GUIDE_SELECTORS.paymentMethodsCard
                                    }
                                ]
                              : [])
                      ]
                  }
              ]
            : []),
        ...(hasPermissions([PermissionsMap.teammates.read, PermissionsMap.teammates.full])
            ? [
                  {
                      title: i18next.t('settings.columnHeader.other'),
                      items: [
                          ...(hasPermissions([
                              PermissionsMap.teammates.read,
                              PermissionsMap.teammates.full
                          ])
                              ? [
                                    {
                                        title: i18next.t('settings.cardTitle.teamManagement'),
                                        description: i18next.t(
                                            'settings.cardDescription.teamManagement'
                                        ),
                                        onClick: () => onCardClick(ROUTES.settings.teamManagement),
                                        classname: USER_GUIDE_SELECTORS.teamManagementCard
                                    }
                                ]
                              : [])
                      ]
                  }
              ]
            : [])
    ]
}
